import '../lib/js-cookie';
import { cookieModule } from './cookies';

const makeIframe = videoId => {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('scrolling', 'no');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allow', 'autoplay');

  if (videoId.length == '5') {
    iframe.src = `https://media.medfarm.uu.se/play/video/embed/${videoId}?autoplay=1`;
  } else {
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  }

  return iframe;
};

const loadVideo = (videoId, element) => {
  let iframe = makeIframe(videoId);
  element.appendChild(iframe);
};

const handleLoadVideo = (videoId, element) => {
  loadVideo(videoId, element);
};

export const video = selector => {
  const videoContainers = [...document.querySelectorAll(selector)];

  if (videoContainers.length) {
    let body = document.querySelector('body');
    body.addEventListener('click', event => {
      const allVideoPlaceholders = document.querySelectorAll(
        '.js-video-cookie-consent',
      );

      if (event.target.classList.contains('js-cookiebanner-accept-btn')) {
        cookieModule.onAcceptCookieClick(event);

        if (allVideoPlaceholders.length) {
          allVideoPlaceholders.forEach(placeholder => {
            placeholder.setAttribute('aria-hidden', true);
          });
        }
      } else if (
        event.target.classList.contains('js-cookiebanner-decline-btn')
      ) {
        cookieModule.onDeclineCookieClick(event);
      }

      const element = event.target.closest(selector);
      if (!element) return;

      const id = element.dataset.videoId;
      if (!id) return;

      const videoPlaceholder = element.querySelector(
        '.js-video-cookie-consent',
      );

      if (!Cookies.get('cookiesIsAccepted')) {
        videoPlaceholder.setAttribute('aria-hidden', false);
      } else {
        const playButton = element.querySelector('.js-video-play');
        playButton ? playButton.classList.add('d-none') : null;

        handleLoadVideo(id, element);
      }
    });
  }
};
